var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hnw-copy",style:({'width':_vm.w+'px'})},[_c('img',{staticClass:"copy-btn",style:({'left':_vm.left+'px','top':_vm.top+'px'}),attrs:{"src":require("../assets/common/copy.png"),"alt":""},on:{"click":function($event){$event.stopPropagation();return _vm.copy.apply(null, arguments)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }